<template>
  <v-card class="px-3 py-1">
    <v-card-title class="px-0 pt-0 pb-7">
      <v-row>
        <v-col cols="8" class="pb-3 pl-3">
          <span class="pb-2 primary--text">{{ formEditTitle }}</span>
        </v-col>
        <v-col cols="4" align="end" class="pt-2 text-right">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="to-right" icon @click="closeModal">
                <v-icon v-bind="attrs" v-on="on">{{ closeIcon }}</v-icon>
              </v-btn>
            </template>
            <span>Cerrar</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="px-0">
      <v-form
        v-model="isFormValid"
        ref="form-edit-version"
        form="form-edit-version"
        id="form-edit-version"
        @submit.prevent="guardar()"
      >
        <v-row>
          <v-col cols="3" class="py-0">
            <v-autocomplete
              v-model="sistemaId"
              :items="sistemas"
              item-text="value"
              item-value="id"
              dense
              hide-details="auto"
              outlined
              @change="loadVersionesBySistema"
              autocomplete="off"
              :disabled="itemVersion !== null"
              :rules="rules.required"
              :filled="itemVersion !== null"
              label="Sistema"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="3" class="py-0">
            <v-autocomplete
              v-model="versionSelected"
              :items="versionesItems"
              item-text="versionNombre"
              item-value="versionId"
              dense
              :loading="loadingVersiones"
              hide-details="auto"
              outlined
              :rules="rules.required"
              autocomplete="off"
              label="Versión"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="3" class="py-0">
            <v-menu
              ref="menu-fecha-baja"
              v-model="menuFecha"
              :close-on-content-click="false"
              :open-on-click="true"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fechaSelected"
                  label="Fecha actualización"
                  :append-icon="'mdi-calendar'"
                  v-bind="attrs"
                  outlined
                  hide-details="auto"
                  dense
                  hint="Formato DD/MM/AAAA"
                  v-mask="'##/##/####'"
                  @blur="fecha = parseDateToIso(fechaSelected)"
                  v-on="on"
                  :rules="rules.required.concat(rules.validDate)"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fecha"
                no-title
                @change="fechaSelected = formatDate(fecha)"
                @input="menuFecha = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="3" class="py-0">
            <v-autocomplete
              v-model="usuariosSelected"
              :items="usuariosItems"
              item-text="nombre"
              item-value="userId"
              label="Usuario"
              outlined
              return-object
              :rules="rules.required"
              hide-details="auto"
              dense
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="12" class="py-4">
            <v-textarea
              v-model="observacion"
              :rules="observacion ? [...rules.required] : []"
              label="Observación"
              dense
              auto-grow
              hide-details="true"
              rows="2"
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="pr-3">
      <v-row class="py-0 pr-0">
        <v-col cols="12" class="pr-0 pt-0 text-right" align="end">
          <v-btn
            color="primary"
            :loading="loadingBtn"
            :disabled="!isFormValid"
            @click="save"
            >Guardar</v-btn
          >
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import rules from "@/utils/helpers/rules";
import { mapGetters } from "vuex";

export default {
  name: "EditVersionCliente",
  props: {
    itemVersion: {
      type: Object,
      default: null,
    },
    clienteId: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      formEditTitle: "Nueva versión cliente",
      closeIcon: "mdi-close",
      loadingBtn: false,
      isFormValid: false,
      sistemaId: null,
      sistemas: [],
      rules: rules,
      fechaSelected: null,
      menuFecha: false,
      fecha: null,
      observacion: "",
      usuariosSelected: [],
      usuariosItems: [],
      versionesItems: [],
      loadingVersiones: false,
      versionSelected: null,
    };
  },
  computed: {
    ...mapGetters({
      userLogged: "user/user",
    }),
  },
  async created() {
    await this.setSelect();
    if (this.itemVersion) await this.setItemVersion();
  },
  methods: {
    ...mapActions({
      getUsuariosInfo: "usuarios/getUsuariosInfo",
      getVersiones: "versiones/getVersiones",
      setAlert: "user/setAlert",
      saveVersionCliente: "versiones/saveVersionCliente",
      sistemasTaxonomy: "clientesData/sistemasTaxonomy",
    }),
    async setItemVersion() {
      this.formEditTitle = "Editar versión cliente";
      this.fechaSelected = this.itemVersion.fechaActualizacion;
      this.fecha = this.parseDateToIso(this.itemVersion.fechaActualizacion);
      this.sistemaId = this.sistemas.find((x) => x.id == this.itemVersion.sistemaId)?.id;
      await this.loadVersionesBySistema();
      this.observacion = this.itemVersion.observaciones;
      this.versionSelected = this.versionesItems.find(
        (x) => x.versionId == this.itemVersion.versionId
      ).versionId;
    },
    async setSelect() {
      const sistemas = await this.sistemasTaxonomy();
      this.sistemas = sistemas;
      const response = await this.getUsuariosInfo(0);
      this.usuariosItems = response;
      if (this.itemVersion == null)
        this.usuariosSelected = this.usuariosItems.find(
          (x) => x.userId == this.userLogged.id
        );
      else
        this.usuariosSelected = this.usuariosItems.find(
          (x) => x.userId == this.itemVersion.usuarioId
        );
    },
    async loadVersionesBySistema() {
      this.versionSelected = null;
      this.loadingVersiones = true;
      try {
        const response = await this.getVersiones(this.sistemaId);
        this.versionesItems = response.data.data;
      } catch (error) {
        this.loadingVersiones = false;
      }
      this.loadingVersiones = false;
    },
    async save() {
      this.loadingBtn = true;
      const data = {
        versionClienteId:
          this.itemVersion !== null ? this.itemVersion.versionClienteId : -1,
        versionId: this.versionSelected,
        clienteId: this.clienteId,
        fechaVersion: this.fecha,
        observaciones: this.observacion,
        usuarioId: this.usuariosSelected.userId,
      };
      try {
        const response = await this.saveVersionCliente(data);
        if (response) {
          this.setAlert({ type: "success", message: "Guardado con éxito." });
          this.closeModal();
        }
      } catch (error) {
        console.error(error);
      }
      this.loadingBtn = false;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDateToIso(date) {
      if (!date) return null;
      if (date.length === 10) {
        const [day, month, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    },
    closeModal() {
      this.$emit("closeAndReload");
    },
  },
};
</script>
  